<template>
  <div class="wrapper" :class="{'nav-open': $sidebar.showSidebar}">
    <notifications></notifications>
    <side-bar>
      <user-menu></user-menu>
 <!-- <mobile-menu></mobile-menu> -->
      <template slot-scope="props" slot="links">
        <sidebar-item :link="{name: 'Home', icon: 'fas fa-chart-pie', path: '/admin/home'}"/>
        <sidebar-item :link="{name: 'Affiliate Accounts', icon: 'fas fa-user-cog', path: '/admin/affiliateAccounts'}"/>
        <sidebar-item :link="{name: 'Incentifyer Accounts', icon: 'fas fa-users-cog', path: '/admin/incentifyerAccounts'}"/>
        <!-- <sidebar-item :link="{name: 'Invoices', icon: 'fas fa-file-alt', path: '/admin/invoices'}"/> -->
        <sidebar-item :link="{name: 'Users', icon: 'fas fa-users', path: '/admin/users'}"/>
        <sidebar-item :link="{name: 'Affiliate Companies', icon: 'fas fa-building', path: '/admin/affiliateCompanies'}"/>
        <sidebar-item :link="{name: 'Payment Cards', icon: 'fas fa-credit-card', path: '/admin/paymentCards'}"/>
        <sidebar-item :link="{name: 'Payouts', icon: 'fas fa-money-check-edit-alt', path: '/admin/payouts'}"/>
        <sidebar-item :link="{name: 'Leads', icon: 'fas fa-inbox-in', path: '/admin/leads'}"/>
        <!-- <sidebar-item :link="{name: 'Setup', icon: 'fas fa-cog', path: '/admin/setup'}"/> -->
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar"/>
      <!-- <dashboard-content v-if="$store.getters.isSetupComplete || $route.path.includes('/setup')" @click.native="toggleSidebar"/>

      <div v-else class="m-4">
        <Welcome-Card class="col-11"/>
      </div> -->
      

      <!-- <content-footer></content-footer> -->
    </div>
  </div>
</template>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import MobileMenu from './Extra/MobileMenu.vue'
  import UserMenu from './Extra/UserMenu.vue'
  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      MobileMenu,
      UserMenu
    },
    // beforeCreate () {
    //   this.$store.dispatch('fetchDataset')
    // },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      }
    }
  }

</script>
